<template>
  <div class="box" :style="isMaring?'margin-bottom: 120px;':''">
    <div class="fot">
      <div class="w1200 dis ads">
        <div class="over">
          <el-image class="fl" src="/static/imgs/di.png" fit="cover" />
          <div class="fl iops"></div>
          <div class="fl fotdi">
            <!-- <div>综合咨询：400-881-3166</div> -->
            <div class="csesa" >占<span style="padding: 0 8px;">经</span>理：180-8672-7328</div>
            <div>祝<span style="padding: 0 8px;">经</span>理：166-0611-9981</div>
          </div>
        </div>
        <div class="over erweima">
          <div class="fl cens-aaa mg50">
            <el-image src="/static/imgs/kefu.jpg" fit="cover" style="width: 113px;height: 113px;" />
            <div class="zt">扫码联系我</div>
          </div>
          <div class="fl cens-aaa">
            <el-image src="/static/imgs/gz.png" fit="cover" />
            <div class="zt">微信公众号</div>
          </div>
        </div>
      </div>
    </div>
    <div class="fd">
      <div class="listy">
        <div class="kols cupo qqs">
          <span>联系我们</span>
          <img src="/static/imgs/kefu.jpg" class="qq-img" />
        </div>
        <div class="kols cupo gzhs">
          <span>公众号</span>
          <img src="/static/imgs/gz.png" class="gzh-img" />
        </div>
        <div class="kols cupo xcxs">
          <span>小程序</span>
          <img src="/static/imgs/xcx.png" class="xcx-img" />
        </div>
      </div>


      <el-image  src="/static/imgs/Frame 427318730@2x.png" fit="cover" @click="goTop"  v-if="show"  class="cupo  jkls" />



    </div>
    <div class="conpys">{{datms.Copyright}}
      <a href="https://beian.miit.gov.cn" target="_blank">{{datms.Copyright2}}</a>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        show: false,
        isMaring: false
      }
    },
    watch: {
      $route(to, from) {
        if (to.path == '/settled') {
          this.isMaring = true
        } else {
          this.isMaring = false
        }
      }
    },
    mounted() {
      window.addEventListener("scroll", this.updateScrollPosition);
    },
    methods: {
      updateScrollPosition() {
        this.show = window.scrollY > 1000 ? true : false
      },
    }
  }
</script>

<style scoped>
  /* 尾 */

  @import url('../../static/css/foot.css');
</style>



// WEBPACK FOOTER //
// src/components/foot.vue